module.exports = __webpack_public_path__ + "img/tool-youtube.cda538e.jpg";